import style from "./style.module.scss";

function FullPagePicture() {
  return <div className={style.FullPagePicture + " row"} style={{ backgroundImage: `url("/Images/testing/image.jpg")` }} />;
}

export default FullPagePicture;